<c-task-list type="'contract'" class="task-list"></c-task-list>